export default "__VITE_ASSET__DwlydD6N__"